module.exports = __webpack_public_path__ + "euro2.gif?f4ffaecf0169cd8a31d13c6749817f62";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/euro2.gif
// module id = 142
// module chunks = 0